import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import React__default, { useState } from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, Box, ExpansionPanel, ExpansionPanelSummary, Typography, ExpansionPanelDetails } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CustomRichText from '../../common/CustomRichText.js';

var useStyles = makeStyles(function (theme) {
  return {
    titleText: {
      fontFamily: "Josefin Sans, sans-serif;",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: theme.spacing(2.25),
      lineHeight: "".concat(theme.spacing(3.375), "px"),
      letterSpacing: "0.02em"
    },
    subtitleText: {
      fontFamily: "Josefin Sans, sans-serif;",
      fontSize: theme.spacing(2),
      fontWeight: 500,
      lineHeight: "".concat(theme.spacing(3), "px")
    },
    expPanelRoot: {
      boxShadow: "unset",
      "&::before": {
        backgroundColor: "unset"
      }
    },
    expPanelRootExpanded: {
      margin: "unset !important"
    },
    expPanelSummaryRoot: {
      padding: 0
    },
    expPanelSummaryContent: {
      flexDirection: "column",
      margin: "20px 0 12px 0 !important"
    },
    expPanelSummaryBtn: {
      marginTop: theme.spacing(1),
      alignSelf: "flex-start"
    },
    expPanelDetailsRoot: {
      padding: 0
    }
  };
});
var ImageWithExpandable = function ImageWithExpandable(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    richText = _ref.richText,
    imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl;
  var classes = useStyles();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setExpanded = _useState2[1];
  var handleChange = function handleChange() {
    setExpanded(!isExpanded);
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    width: "100%"
  }, imageUrl && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    width: "100%",
    src: imageUrl,
    alt: imageTitle || ""
  }), /*#__PURE__*/React__default.createElement(ExpansionPanel, {
    square: true,
    classes: {
      root: classes.expPanelRoot,
      expanded: classes.expPanelRootExpanded
    },
    onChange: handleChange
  }, /*#__PURE__*/React__default.createElement(ExpansionPanelSummary, {
    expandIcon: isExpanded ? /*#__PURE__*/React__default.createElement(RemoveIcon, null) : /*#__PURE__*/React__default.createElement(AddIcon, null),
    IconButtonProps: {
      disableFocusRipple: true,
      disableRipple: true
    },
    classes: {
      root: classes.expPanelSummaryRoot,
      content: classes.expPanelSummaryContent,
      expandIcon: classes.expPanelSummaryBtn
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.titleText,
    align: "left"
  }, title), /*#__PURE__*/React__default.createElement(Typography, {
    align: "left"
  }, subtitle)), /*#__PURE__*/React__default.createElement(ExpansionPanelDetails, {
    classes: {
      root: classes.expPanelDetailsRoot
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    component: "div"
  }, /*#__PURE__*/React__default.createElement(CustomRichText, {
    document: richText
  })))));
};
ImageWithExpandable.propTypes = {
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  richText: PropTypes__default.object,
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string.isRequired
};

export { ImageWithExpandable as default };
//# sourceMappingURL=ImageWithExpandable.js.map
